import React from 'react';
import SvgIcon from './SvgIcon'

import helpers from '../lib/helpers';

import SafeLink from './SafeLink';

export default (props) => {
  return (
    <div className="o-container">
        <div className="p-infobox__wrapper">
          <div className="p-infobox__inner">
            <div className="p-infobox__title-wrapper">
            </div>
              {props.boxes &&
                props.boxes.map((box, index) => (
                <div key={index} className="nsw-in-page-alert nsw-in-page-alert--info nsw-in-page-alert--compact">
                  <span
                    className="material-icons nsw-material-icons nsw-in-page-alert__icon"
                    tabIndex="-1"
                    aria-hidden="true"
                    translate="no"
                  >
                    info
                  </span>
                  <div className="nsw-in-page-alert__content">
                    {box.title && <p className="nsw-h5">{box.title}</p>}
                    <p className="nsw-in-page-alert__content__description">{box.content}</p>
                  </div>
                </div>

                ))}
          </div>
        </div>
      </div>
  );
}